<div class="time-select-container">
    <label *ngIf="label">{{ label | translate }}</label>
    <div class="d-flex gap-2">
        <ng-container>
            <input type="text" class="form-control" [(ngModel)]="timeValue" format="24" [ngxMatTimepicker]="timePicker"
                (ngModelChange)="onTimePickerChange()" [disabled]="disabled" hidden>
            <ngx-mat-timepicker #timePicker></ngx-mat-timepicker>

            <button (click)="timePicker.open()" type="button" class="icon-btn" [disabled]="disabled">
                <span style="font-size: 14px;" class="mx-1">{{ displayValue }}</span>
                <img height="18px" src="/assets/images/icons/edit.svg" alt="">
            </button>
        </ng-container>

        <button *ngIf="hasValue && !required" (click)="clearTime()" type="button" class="icon-btn"
            [disabled]="disabled">
            <img height="18px" src="/assets/images/icons/delete.svg" alt="">
        </button>
    </div>

    <div *ngIf="hasErrors" class="feedback">
        <div *ngFor="let errorKey of errorMessages">
            {{ errorKey | translate }}
        </div>
    </div>
</div>